import { Injectable } from '@angular/core';
import { EstablecimientosService } from '@core/yalo';
import { DrawersService, FilterDef } from '@shared/drawers';
import { BehaviorSubject, forkJoin, from } from 'rxjs';
import { filter, take, tap, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InformesFiltersService {
  private _establecimientoFilter = new BehaviorSubject<FilterDef[]>([]);
  readonly establecimientoFilter$ = this._establecimientoFilter.asObservable();

  private _puntosEmision: any[] = [];
  private _establecimientos: any[] = [];



  constructor(
    private _establecimientosService: EstablecimientosService,
    private _drawers: DrawersService
  ) {}

  async cargarEstablecimientosFilter() {
    const data = await this._establecimientosService.establecimientosBodegas$
      .pipe(
        filter((establecimientos) => establecimientos.length > 0),
        take(1)
      ).toPromise();

    const codEstablecimiento = await this._establecimientosService.getCodEstablecimiento();

    const filters: FilterDef[] = [{
      type: 'checkbox',
      headerName: 'Establecimiento',
      field: 'CodEstablecimiento',
      filterDefs: data.map(({ CodEstablecimiento, NombreEstablecimiento }) => ({
        value: CodEstablecimiento,
        label: NombreEstablecimiento,
        selected: CodEstablecimiento === codEstablecimiento,
      })),
      expanded: false,
    }];
  }
  cargarFiltros() {
    const currentFilters = this._establecimientoFilter.getValue();
    const hasExistingFilters = currentFilters.length > 0;

    return forkJoin({
      establecimientos: this._establecimientosService.establecimientosBodegas$.pipe(
        filter((establecimientos) => establecimientos.length > 0),
        take(1)
      ),
      puntosEmision: from(this._establecimientosService.getPuntosEmision())
    }).pipe(
      tap(({ establecimientos, puntosEmision }) => {
        this._establecimientos = establecimientos;
        this._puntosEmision = puntosEmision;

        const selectedEstablecimientos = hasExistingFilters
          ? currentFilters[0]?.filterDefs.filter(def => def.selected).map(def => def.value)
          : establecimientos.map(est => est.CodEstablecimiento);

        this.updateFilters(selectedEstablecimientos || []);
      }),
      map(({ establecimientos, puntosEmision }) => ({
        establecimientos,
        puntosEmision
      }))
    );
  }


  getSelectedFilters() {
    const filtersArr = this._establecimientoFilter.getValue();
    const filters = {
      establecimientos: filtersArr[0]?.filterDefs.filter(def => def.selected).map(def => def.value) || [],
      puntosEmision: filtersArr[1]?.filterDefs.filter(def => def.selected).map(def => def.value) || []
    };
    return filters;
  }

  private getEstablecimientosFilter(selectedEstablecimientos: number[]): FilterDef {
    return {
      type: 'checkbox',
      headerName: 'Establecimiento',
      field: 'CodEstablecimiento',
      filterDefs: this._establecimientos.map(({ CodEstablecimiento, NombreEstablecimiento }) => ({
        value: CodEstablecimiento,
        label: NombreEstablecimiento,
        selected: selectedEstablecimientos.includes(CodEstablecimiento),
      })),
      expanded: false,
    };
  }

  private getPuntosEmisionFilter(selectedEstablecimientos: number[], selectedPointsOfSale?: number[]): FilterDef {
    const currentFilters = this._establecimientoFilter.getValue();
    const unselectedPoints = currentFilters[1]?.filterDefs
    .filter(p => !p.selected)
    .map(p => p.value) || [];

    return {
      type: 'checkbox',
      headerName: 'Puntos de Emisión',
      field: 'CodPuntoEmision',
      filterDefs: this._puntosEmision
        .filter(punto => selectedEstablecimientos.includes(punto.Codestablecimiento))
        .map(punto => ({
          value: punto.Codpuntoemision,
          label: punto.Nombrepuntoemision,
          selected: selectedPointsOfSale !== undefined
            ? selectedPointsOfSale.includes(punto.Codpuntoemision)
            : !unselectedPoints.includes(punto.Codpuntoemision),
        })),
      expanded: false,
    };
  }

  updateFilters(selectedEstablecimientos: number[], selectedPointsOfSale?: number[]) {
    const filters: FilterDef[] = [
      this.getEstablecimientosFilter(selectedEstablecimientos),
      this.getPuntosEmisionFilter(selectedEstablecimientos, selectedPointsOfSale)
    ];

    this._establecimientoFilter.next(filters);
    this._drawers.setFilterDefs(filters);
  }

}
